import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=0892d261&scoped=true"
import script from "./Whiteboard.vue?vue&type=script&lang=ts"
export * from "./Whiteboard.vue?vue&type=script&lang=ts"
import style0 from "./Whiteboard.vue?vue&type=style&index=0&id=0892d261&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892d261",
  null
  
)

export default component.exports